import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OauthConfigService, RbacService } from '@stg-js-ngx-core/oauth';
import { from, Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { PARTNER_REALM, AAIMS_PARTNER_USER } from '../mmt-constants';
import { environment } from '../../../environments/environment';
import { MmtCommonService } from './mmt-common.service';
import { AppConfigService } from '../../appServiceConfig';

declare var aaimsCommonService: any;

@Injectable({
  providedIn: 'root'
})
export class UserAdministrationService {

  constructor(
    private http: HttpClient,
    private rbacService: RbacService,
    private oauthConfigService: OauthConfigService,
    private commonService: MmtCommonService,
    private appConfigService: AppConfigService
  ) {
    // Override the library's default rootContext ('/ui') to route through .NET API
    // Set full URL so it works both locally and in production
    try {
      const mmtApiUrl = this.appConfigService.getConfig().api.mmt;
      if (mmtApiUrl) {
        aaimsCommonService.setRootContext(mmtApiUrl);
      }
    } catch (e) { }
  }

  createUser(request): Observable<any> {
     return from(aaimsCommonService.addUser(this.oauthConfigService.oauthToken, request.userInfo, PARTNER_REALM,
      AAIMS_PARTNER_USER, request.userInfo.email, request.resources));
  }

  updateUser(request): Observable<any> {
    return from(aaimsCommonService.changeUser(this.oauthConfigService.oauthToken, request.userInfo.userKey, request.userInfo, true,
      PARTNER_REALM, AAIMS_PARTNER_USER, request.userInfo.email, request.resources));
  }

  enableOrDisableUser(key, enableOrDisableStatus, resources): Observable<any> {
    const httpParams = new HttpParams().set('key', key);
    const body = {
      status: enableOrDisableStatus,
      resources: resources || []
    };
    return this.http.post(environment.urls.aaimsChangeStatus, body, { params: httpParams });
  }

  getUserKey(request): Observable<any> {
    const httpParams = new HttpParams().set('key', request.userInfo.key);
    return this.http.get(environment.urls.aaimsGetUser, { params: httpParams });
  }

  // getSecurityQuestions() {
  //   return aaimsCommonService.getSecurityQuestions(this.oauthConfigService.oauthToken);
  // };

  // getSecurityQuestionByUser(userName: string) {
  //   return aaimsCommonService.getSecurityQuestionByUser(this.oauthConfigService.oauthToken, userName);
  // };

  getUser(key): Observable<any> {
    const httpParams = new HttpParams().set('key', key);
    return this.http.get(environment.urls.aaimsGetUser, { params: httpParams });
  }

  // changePassword(userKey, password, resources) {
  //   return aaimsCommonService.changePassword(this.oauthConfigService.oauthToken, userKey, password, resources);
  // };

  // changeSecurityQuestion(key, questionKey, answer) {
  //   return aaimsCommonService.changeSecurityQuestion(this.oauthConfigService.oauthToken, key, questionKey, answer);
  // };

  resetSecurity(request, key): Observable<any> {
    const httpParams = new HttpParams().set('key', key);
    const body = {
      resources: request.resources || []
    };
    return this.http.patch(environment.urls.aaimsResetSecurity, body, { params: httpParams });
  }

  getAAIMSResources(): Observable<any> {
    return this.http.get(environment.urls.aaimsResources);
  }

  insertUser(data): Observable<any> {
    return this.http.post(environment.urls.insertUser, data);
  }

  updateUserInMMT(data): Observable<any> {
    return this.http.put(environment.urls.updateUser, data);
  }

  insertAAIMSUser(data):Observable<any> {
    return this.http.post(environment.urls.aaimsUser,data)
  }
  
  getAdamsUsers(search: string, username?: string): Observable<any> {
    username = username ? username : this.rbacService.username;
    const role = this.rbacService.currentRoleName ? this.rbacService.currentRoleName : 'BLOCKED';
    const httpParams = new HttpParams().set('limit', '10000')
      .set('userName', username)
      .set('page', '1')
      .set('appName', this.rbacService.rbacAppName)
      .set('roleName', role)
      .set('search', search);
    return this.http.get(environment.urls.adamsUsers, { params: httpParams });
  }

  getUserByUserName(username: string): Observable<any> {
    const httpParams = new HttpParams().set('username', username);
    return this.http.get(environment.urls.user, { params: httpParams });
  }

  assignRole(username, application, role, teamData): Observable<any> {
    const jsonString = JSON.stringify(teamData),
      jsonObject = JSON.parse(jsonString),
      accessObject = {
        data: {
          username: username,
          application: application,
          role: role,
          teams: jsonObject
        }
      };
    return this.http.post(environment.urls.userRoles, accessObject);
  }

  deleteUser(
    username: string,
    role: string,
    team: string,
    email: string,
    cc: string,
    name: string
  ): Observable<any> {
    const httpParams = new HttpParams()
      .set('username', username)
      .set('application', this.rbacService.rbacAppName)
      .set('role', role)
      .set('team', team)
      .set('userop', this.rbacService.username)
      .set('email', email)
      .set('cc', cc)
      .set('name', name);
    return this.http.delete(environment.urls.deleteUser, { params: httpParams });
  }

  updateDefaultTeam(username, application, role, team): Observable<any> {
    const httpParams = new HttpParams().set('username', username)
      .set('application', application)
      .set('role', role)
      .set('team', team)
    return this.http.put(environment.urls.updateDefaultTeam, {}, { params: httpParams })
      .pipe(
        mergeMap(() => {
          return this.commonService.getDefaultHospital();
        }),
        catchError(err => throwError(err))
      );
  }

  getOMSAccess(): Observable<any> {
    return this.http.get(environment.urls.omsAccess, { responseType: "text" });
  }
}
